/**
 * Input-mode handling for the order-tote-mapping ("Assign Tote") field.
 *
 * When the operator presses the put-wall gate button, the tote field must be
 * focused immediately so a hardware barcode scanner can enter the tote ID, but
 * the on-screen keyboard must stay hidden so it doesn't cover the screen. A
 * scanner delivers HID keystrokes regardless of `inputMode`, so `"none"` keeps
 * scanning working while suppressing the soft keyboard. Only an explicit tap on
 * the field switches to `"text"`, which reveals the keyboard for manual entry.
 */
export type ToteInputMode = "none" | "text";

/** Auto-focused for scanning; on-screen keyboard suppressed. */
export const TOTE_SCAN_INPUT_MODE: ToteInputMode = "none";

/** Manual entry after an explicit tap; on-screen keyboard allowed. */
export const TOTE_MANUAL_INPUT_MODE: ToteInputMode = "text";

/**
 * Resolve the field's `inputMode` from whether the operator has explicitly
 * tapped it. Programmatic auto-focus (for the scanner) leaves `hasTapped`
 * false, so the keyboard stays hidden until a real tap flips it.
 */
export function resolveToteInputMode(hasTapped: boolean): ToteInputMode {
  return hasTapped ? TOTE_MANUAL_INPUT_MODE : TOTE_SCAN_INPUT_MODE;
}
